import Auth from './Auth.js'
import axios from 'axios';
// import ConfigAxios from './ConfigAxios.js';

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.sktunion.com' : 'http://localhost:8080';


// Set X-Nominee-Token header dynamically
axios.interceptors.request.use((config) => {
  const token = Auth.getToken()
  if (token) {
    config.headers['X-Nominee-Token'] = token
  }
  return config
})

// ConfigAxios.initInterceptors(axios)

export default {
    instance() {
        return axios
    },

}